// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"M8-z"};